export default "__VITE_ASSET__CstX7rrM__"